import { Metrics } from '../../../core/metrics/metrics.model';
import { JobStatus } from '../../scenario/model/scenario-job-dto.model';
import { IScenario } from "../../scenario/model/scenario.model";

export interface IProduct {
  id?: number;
  name: string;
  metrics?: Metrics;
  state: string;
  processingStart?: string;
  processingEnd?: string;
  config?: ProductConfig;
  internal?: boolean;
  orgId?: string;
  scenarioCount?: number;
  productCategories?: string[];
  segmentCount?: number;
  currentProductJob?: IProductJobDto;
  frozen?: boolean;
  type?: ProductType;
  uaScenarioId?: number;
  uaScenario?: IScenario;
}

export interface IProductJobDto {
  errors?: { [key: string]: any };
  id?: number;
  processingStart?: string;
  processingEnd?: string;
  state?: JobStatus | string;
}

export enum ProductType {
  BUDGETING = 'BUDGETING',
  USER_ACQUISITION = 'USER_ACQUISITION',
}

export class Product implements IProduct {
  constructor(
    public id?: number,
    public metrics?: Metrics,
    public name: string = 'Product',
    public state = 'No data',
    public processingStart?: string,
    public processingEnd?: string,
    public config?: ProductConfig,
    public internal?: boolean,
    public type?: ProductType,
    public orgId?: string,
    public scenarioCount?: number,
    public productCategories?: string[],
    public segmentCount?: number,
    public currentProductJob?: IProductJobDto,
    public frozen?: boolean,
    public uaScenarioId?: number
  ) {
  }
}

export interface PaidCategory {
  category: string;
  paidValues: string[];
}

export interface ProductConfig {
  financialYearEnd: number;
  grossMarginPercentage?: number;
  paidCategory?: PaidCategory;
}

export interface IProductStats {
  revenueTotal?: number;
  customerTotal?: number;
  transactionTotal?: number;
}

export class ProductStats implements IProductStats {
  constructor(
    public revenueTotal?: number,
    public customerTotal?: number,
    public transactionTotal?: number,
  ) {
  }
}

export class ProductRevenueStats {
  constructor(public value: number, public date: Date) {
  }
}

export enum FileUploadType {
  NEW_USER_OVERRIDE = 'NEW_USER_OVERRIDE',
  MONETISATION_OVERRIDE = 'MONETISATION_OVERRIDE',
  CLF_ACTIVITY = 'CLF_ACTIVITY',
  AGGREGATED_ACTIVITY = 'AGGREGATED_ACTIVITY',
  RETENTION_OVERRIDE = 'RETENTION_OVERRIDE',
  DAU_MULTIPLIER = 'DAU_MULTIPLIER',
}

export enum FileState {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export class UploadedFile {
  public id?: number;
  public productId: number;
  public filename: string;
  public type?: FileUploadType;
  public state?: FileState;
  public message?: string;
  public processingStart: Date;
  public processingEnd: Date;

}

export interface Category {
  id: string;
  category: string;
  values: CategoryValues[]
}

export interface CategoryValues {
  id: string;
  value: string;
  category: string;
}
